import { Alert, Button, Flex, Tooltip } from "@fluentui/react-northstar";
import { app } from "@microsoft/teams-js";
import { TeamsSurveyState } from "@teams/types";
import { SurveyDTO } from "@teams/types/api";
import { useEffect, useState } from "react";
import React from "react";

import { isError } from "../../../_shared/services/ChannelApi";
import { surveyApi } from "../../../_shared/services/SurveyApi";
import { startPollyReopenTask } from "../../../_shared/utils/startTaskWrapper";
import { AnswerSurveyButton } from "./components/AnswerSurveyButton";
import { SendSurveyButton } from "./components/SendSurveyButton";

export const SurveySideBarCardFooter: React.FC<{
  teamsContext: app.Context;
  survey: SurveyDTO;
  userHasResponded: boolean;
  onChanged: (newSurveyState?: TeamsSurveyState) => void;
  onResponded: () => void;
}> = ({ teamsContext, survey, userHasResponded, onChanged, onResponded }) => {
  const [isClosing, setIsClosing] = useState<boolean>();
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    setIsClosing(false);
    if (survey.state === "open") {
      setError(undefined);
    }
  }, [survey.state]);

  let showAnswerButton = false;
  // never show answer button for qna and hot-take
  if (survey.type === "qna" || survey.type === "hot-take") {
    showAnswerButton = false;
  } else if (!userHasResponded || survey.type === "trivia" || survey.type === "icebreaker") {
    showAnswerButton = survey.state === "open";
  }

  return (
    <Flex fill hAlign="end" gap="gap.smaller" wrap>
      {error && <Alert danger content={error} attached="bottom" />}
      {showAnswerButton && (
        <AnswerSurveyButton
          label={survey.type === "trivia" ? "Join Trivia" : "Answer"}
          onResponded={onResponded}
          survey={survey}
          fluid={survey.role !== "own" || survey.state !== "open"}
        />
      )}
      {survey.role === "own" && survey.state === "pending" && !survey.deliverAt && (
        <SendSurveyButton
          survey={survey}
          teamsContext={teamsContext}
          onChanged={() => {
            setError(undefined);
            onChanged();
          }}
          onError={errorMessage => {
            setError(errorMessage);
          }}
        />
      )}
      {survey.role === "own" && survey.state === "open" && (
        <Tooltip content="Close for any further responses">
          <Flex styles={{ flex: 1 }}>
            <Button
              secondary
              fluid
              loading={isClosing}
              disabled={isClosing}
              onClick={async () => {
                setIsClosing(true);

                const result = await surveyApi.closeSurvey(
                  teamsContext,
                  survey.id as string,
                  new Date()
                );
                if (isError(result)) {
                  console.error(result);
                  return;
                }

                onChanged("closed");
              }}
              content="Close Polly"
            />
          </Flex>
        </Tooltip>
      )}

      {survey.role === "own" && survey.state === "closed" && survey.type !== "trivia" && (
        <Tooltip content="Reopen this Polly to collect additional responses">
          <Button
            secondary
            fluid
            onClick={async () => {
              startPollyReopenTask(survey, () => {
                onChanged();
              });
              onChanged("open");
            }}
            content="Reopen Polly"
          />
        </Tooltip>
      )}
    </Flex>
  );
};
